import type { BillingTabData } from './types';

// Billing details page i18n keys
export const COMBINE_BILLING_DETAILS_HEADING_KEY =
  'combine_billing_details_heading';
export const COMBINE_BILLING_DETAILS_DESCRIPTION_KEY =
  'combine_billing_details_description';
export const COMBINE_BILLING_DETAILS_ALERT_KEY =
  'combine_billing_details_alert';

export const COMBINE_BILLING_TAB_SA_KEY = 'combine_billing_tab_sa';
export const COMBINE_BILLING_TAB_DSP_KEY = 'combine_billing_tab_dsp';

export const COMBINE_BILLING_INVOICE_RECIPIENT_LABEL_KEY =
  'combine_billing_invoice_recipient_label';
export const COMBINE_BILLING_ADDRESS_LABEL_KEY =
  'combine_billing_address_label';
/**
 * Replaces the address value for a seller, whose billing details are maintained in Seller
 * Central. Carries a `{link}` placeholder for the click-through, so it must be rendered with
 * `intl.formatMessage`, never `getMessage`.
 */
export const COMBINE_BILLING_ADDRESS_SELLER_CENTRAL_KEY =
  'combine_billing_address_seller_central';
/** Link text rendered as the `{link}` argument of the string above. */
export const COMBINE_BILLING_ADDRESS_SELLER_CENTRAL_LINK_KEY =
  'combine_billing_address_seller_central_link';

export const COMBINE_BILLING_RECIPIENT_ADVERTISER_KEY =
  'combine_billing_recipient_advertiser';
export const COMBINE_BILLING_RECIPIENT_MANAGER_KEY =
  'combine_billing_recipient_manager';

export const COMBINE_BILLING_PAYMENT_PROFILES_LABEL_KEY =
  'combine_billing_payment_profiles_label';
export const COMBINE_BILLING_PAYMENT_COUNTRIES_TAG_KEY =
  'combine_billing_payment_countries_tag';

/** Maps backend paymentMethodType values to display label i18n keys. */
export const COMBINE_BILLING_PAYMENT_TYPE_LABEL_KEYS: Record<string, string> = {
  CREDIT_CARD: 'combine_billing_payment_type_credit_card',
  PAY_BY_INVOICE: 'combine_billing_payment_type_pay_by_invoice',
  SELLER_PAYABLE: 'combine_billing_payment_type_seller_account_balance',
  VENDOR_CODE: 'combine_billing_payment_type_vendor_codes',
};

export const COMBINE_BILLING_LOADING_KEY = 'combine_billing_loading';
export const COMBINE_BILLING_ERROR_KEY = 'combine_billing_error';
export const COMBINE_BILLING_MISSING_PARAMS_KEY =
  'combine_billing_missing_params';

/**
 * Rendered on the DSP tab when the backend returns no DSP billing data
 * (for example, the caller lacks Manager Account access). DSP accounts in
 * the combine flow are always invoiced to the Manager Account, so the
 * invoicing type is displayable without access to the MA's billing data;
 * addresses and payment methods stay hidden.
 *
 * `sellerCentralUrl` is null rather than absent because it is only ever set on the Sponsored
 * ads side, so the DSP tab has nothing to point at even when the real data does arrive.
 */
export const DSP_BILLING_FALLBACK: BillingTabData = {
  invoiceRecipient: 'MANAGER_ACCOUNT',
  billingAddresses: null,
  sellerCentralUrl: null,
  paymentMethods: null,
};
